import stringUtils from '../../utils/stringUtils';
import {assetMapping} from './iccMarketMappings';

export const getMediaId = (material, isHolderAsset = false) => {
    if (!material) return null;

    try {
        const mediaIdParts = [
            material.materialGroup || material.device_material_group,
            material.materialBrandFamily,
            material.materialModelNumber,
            material.materialColor,
        ];

        const isValidParts = !mediaIdParts.some((x) => !x);

        if (!isValidParts) return null;

        const mediaName = mediaIdParts.join('_');

        return isHolderAsset ? null : assetMapping(mediaName);
    } catch (e) {
        return null;
    }
};

export const getErrorMapping = (error) => {
    return {
        errorCode: stringUtils.toString(error?.outerErrorCode || error?.errorCode),
        errorMessage: stringUtils.toString(error?.outerErrorMessage || error?.errorMessage),
    };
};
